export const EnableSherpathAIFeatureFlagValue = 'ENABLED';
